/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdditionalCarrierFee
 */
export interface AdditionalCarrierFee {
  /**
   *
   * @type {string}
   * @memberof AdditionalCarrierFee
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof AdditionalCarrierFee
   */
  feeAmountCad?: number;
  /**
   *
   * @type {number}
   * @memberof AdditionalCarrierFee
   */
  feeAmountUsd?: number;
  /**
   *
   * @type {string}
   * @memberof AdditionalCarrierFee
   */
  documentReference?: string;
}

/**
 * Check if a given object implements the AdditionalCarrierFee interface.
 */
export function instanceOfAdditionalCarrierFee(
  value: object,
): value is AdditionalCarrierFee {
  return true;
}

export function AdditionalCarrierFeeFromJSON(json: any): AdditionalCarrierFee {
  return AdditionalCarrierFeeFromJSONTyped(json, false);
}

export function AdditionalCarrierFeeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalCarrierFee {
  if (json == null) {
    return json;
  }
  return {
    description: json["description"] == null ? undefined : json["description"],
    feeAmountCad:
      json["feeAmountCad"] == null ? undefined : json["feeAmountCad"],
    feeAmountUsd:
      json["feeAmountUsd"] == null ? undefined : json["feeAmountUsd"],
    documentReference:
      json["documentReference"] == null ? undefined : json["documentReference"],
  };
}

export function AdditionalCarrierFeeToJSON(json: any): AdditionalCarrierFee {
  return AdditionalCarrierFeeToJSONTyped(json, false);
}

export function AdditionalCarrierFeeToJSONTyped(
  value?: AdditionalCarrierFee | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    description: value["description"],
    feeAmountCad: value["feeAmountCad"],
    feeAmountUsd: value["feeAmountUsd"],
    documentReference: value["documentReference"],
  };
}
